
import React, {
  useState
} from "react";

import {
  signInWithPopup,
  GoogleAuthProvider
} from "firebase/auth";

import {
  auth
} from "../firebase";

const provider =
  new GoogleAuthProvider();

provider.setCustomParameters({
  prompt: "select_account"
});

export default function GalleryPartnerOpportunity() {

  const [loading, setLoading] =
    useState(false);

  const login =
    async () => {

      try {

        setLoading(true);

        const result =
          await signInWithPopup(
            auth,
            provider
          );

        console.log(
          "Gallery Login:",
          result.user.uid
        );

      } catch (err) {

        console.error(err);

        alert(
          err?.message ||
          "Login failed"
        );

      } finally {

        setLoading(false);

      }

    };

  return (

    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: 24,
        background:
          "radial-gradient(circle at top left,#60a5fa,#7c3aed,#111827)"
      }}
    >

      <div
        style={{
          width: "100%",
          maxWidth: 650,
          background:
            "rgba(255,255,255,.97)",
          borderRadius: 34,
          padding: 34,
          boxShadow:
            "0 35px 80px rgba(0,0,0,.25)",
          textAlign: "center"
        }}
      >

        <div
          style={{
            width: 90,
            height: 90,
            margin:
              "0 auto 20px",
            borderRadius: "50%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: 42,
            color: "#fff",
            background:
              "linear-gradient(135deg,#2563eb,#7c3aed,#ec4899)"
          }}
        >
          🎨
        </div>

        <h1
          style={{
            margin: 0,
            fontSize: 36,
            fontWeight: 900
          }}
        >
          Gallery Partner Opportunity
        </h1>

        <p
          style={{
            marginTop: 16,
            color: "#6b7280",
            lineHeight: 1.7
          }}
        >
          Join PITICS Gallery and
          share educational content
          with students, teachers
          and parents.
        </p>

        <div
          style={{
            textAlign: "left",
            marginTop: 25,
            marginBottom: 25,
            background: "#f8fafc",
            padding: 20,
            borderRadius: 18
          }}
        >

          <h3>
            You Can Upload
          </h3>

          <p>✅ Drawings</p>

          <p>✅ Coloring Pages</p>

          <p>✅ Educational Worksheets</p>

          <p>✅ Activities</p>

          <p>✅ Posters</p>

          <p>✅ Charts</p>

          <p>✅ School Resources</p>

        </div>

        <button
          onClick={login}
          disabled={loading}
          style={{
            width: "100%",
            padding: "16px 20px",
            border: "none",
            borderRadius: 999,
            cursor:
              loading
                ? "not-allowed"
                : "pointer",
            fontSize: 16,
            fontWeight: 900,
            color: "#fff",
            background:
              "linear-gradient(135deg,#2563eb,#7c3aed,#ec4899)",
            boxShadow:
              "0 18px 35px rgba(124,58,237,.35)",
            opacity:
              loading
                ? 0.7
                : 1
          }}
        >
          {loading
            ? "Signing In..."
            : "Continue With Google"}
        </button>

      </div>

    </div>

  );

}

